/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingSpinnerComponent {
}
